export class PlanGoodsContainModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 容器包装材区分
  public containDiv: string = <string>'';

  // 容器包装材分類
  public containKind: string = <string>'';

  // 包材重量
  public packMaterialWeight: string = <string>'';

  // 容器包装材選択
  public containSelect: string = <string>'';
}
